import { L10n, setCulture } from "@syncfusion/ej2-base";

let initialized = false;

export function initializeSyncfusionLocales() {
  if (initialized) return;
  initialized = true;

  L10n.load({
    "de-DE": {
      grid: {
        EmptyRecord: "Keine Datensätze zum Anzeigen",
        Add: "Hinzufügen",
        Edit: "Bearbeiten",
        Delete: "Löschen",
        Update: "Speichern",
        Cancel: "Abbrechen",
        GroupDropArea:
          "Ziehen Sie eine Spaltenüberschrift hierher, um zu gruppieren",
        UnGroup: "Gruppierung aufheben",
      },
      pager: {
        currentPageInfo: "{0} von {1} Seiten",
        totalItemInfo: "({0} Einträge)",
        firstPageTooltip: "Erste Seite",
        lastPageTooltip: "Letzte Seite",
        nextPageTooltip: "Nächste Seite",
        previousPageTooltip: "Vorherige Seite",
        nextPagerTooltip: "Nächste Pager-Elemente",
        previousPagerTooltip: "Vorherige Pager-Elemente",
        pagerDropDown: "Einträge pro Seite",
        pagerAllDropDown: "Einträge",
        All: "Alle",
        Page: "Seite",
        Of: "von",
        Pages: "Seiten",
      },
    },
    "en-US": {
      grid: {
        EmptyRecord: "No records to display",
        Add: "Add",
        Edit: "Edit",
        Delete: "Delete",
        Update: "Save",
        Cancel: "Cancel",
        GroupDropArea: "Drag a column header here to group by that column",
        UnGroup: "Ungroup",
      },
      pager: {
        currentPageInfo: "{0} of {1} pages",
        totalItemInfo: "({0} items)",
        firstPageTooltip: "First page",
        lastPageTooltip: "Last page",
        nextPageTooltip: "Next page",
        previousPageTooltip: "Previous page",
        nextPagerTooltip: "Next pager items",
        previousPagerTooltip: "Previous pager items",
        pagerDropDown: "Items per page",
        pagerAllDropDown: "Items",
        All: "All",
        Page: "Page",
        Of: "of",
        Pages: "pages",
      },
    },
  });
}

export function applySyncfusionLocale(locale) {
  initializeSyncfusionLocales();
  setCulture(locale);
}
